import { render, staticRenderFns } from "./receivableManage.vue?vue&type=template&id=6213201d&scoped=true"
import script from "./receivableManage.vue?vue&type=script&lang=js"
export * from "./receivableManage.vue?vue&type=script&lang=js"
import style0 from "./receivableManage.vue?vue&type=style&index=0&id=6213201d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213201d",
  null
  
)

export default component.exports